import * as React from 'react';
import { Link } from 'react-router-dom';
import { Feed } from '../feed';
import { countries, Country } from 'typed-countries';
import * as dateFormat from 'dateformat';

export interface FeedListItemProps {
  feed: Feed;
}

const DATE_FORMAT = 'dddd, d mmmm, yyyy - HH:MM:s';
const WORLDWIDE = 'Worldwide';

const indicatorClasses = (active: boolean) => {
  return `db w1 h1 br-100 bg-${active ? 'green' : 'red'}`;
};

const feedVisibility = (feed: Feed) => {
  if (feed.visible_worldwide) {
    return WORLDWIDE;
  }

  return feed.visible_in
    .map((item: string) => {
      const country = countries.find(
        (country: Country) => country.iso === item,
      );
      if (country) {
        return country.name;
      }

      return item;
    })
    .join(', ');
};

export function FeedListItem(props: FeedListItemProps) {
  return (
    <div className="flex justify-stretch items-center pv2">
      <div className="mr4">
        <div className={indicatorClasses(props.feed.active)} />
      </div>
      <div className="flex-auto w-30">
        <h4 className="lh-title ma0 mb2">{props.feed.name}</h4>
        <p className="lh-copy ma0 f6 black-50">
          Visible from: {dateFormat(props.feed.visible_from, DATE_FORMAT)}
        </p>
      </div>
      <div className="flex-auto w-40">
        <p className="lh-copy ma0 mb2 f6 black-50">Territories</p>
        {feedVisibility(props.feed)}
      </div>
      <div>
        <Link
          to={{
            pathname: '/feeds/edit/new',
            state: {
              feed: { ...props.feed, id: null },
            },
          }}
          className="link black underline b dib ml3"
        >
          Copy
        </Link>
        <Link
          to={{
            pathname: `/feeds/edit/${props.feed.id}`,
            state: {
              feed: props.feed,
            },
          }}
          className="link black underline b dib ml3"
        >
          Edit
        </Link>
      </div>
    </div>
  );
}
